import { createContext } from 'react';

// Kept outside the page components so child components can consume them without importing their parent page
// (which created circular imports).
export const EditContext = createContext(null);
export const EditExpenseContext = createContext(null);
